<template>
  <div @mouseleave="mouseLeaveFn" ref="bannerNode" @mouseenter="mouseEnterFn" class="photos_img">
    <div @click="leftBtnFn" ref="leftBtnNode" v-show="imgArr.length > 1" class="left_btn_img"></div>
    <div @click="rightBtnFn" ref="rightBtnNode" v-show="imgArr.length > 1" class="right_btn_img"></div>
    <ul ref="contentNode" class="banner_img" :style="{ width: `${(imgArr.length + 1) * 100}%` }">
      <li
        :style="{ width: `${100 / (imgArr.length + 1)}%` }"
        v-for="(imgSrc, index) in imgArr"
        :key="index"
      >
        <img :src="imgSrc" alt="项目图片" />
      </li>
      <li :style="{ width: `${100 / (imgArr.length + 1)}%` }">
        <img :src="imgArr[0]" alt="项目图片" />
      </li>
    </ul>
    <ul class="circle_img" v-show="imgArr.length > 1">
      <li :class="{
        on: hightIndex == index
      }" @click="clickLi(index)" v-for="(item, index) in imgArr" :key="index"></li>
    </ul>
  </div>
</template>
<script>
function getStyleValue (node, attr) {
  var styleNode
  if (node.currentStyle == undefined) {
    styleNode = getComputedStyle(node, null)
  } else {
    styleNode = node.currentStyle
  }
  return styleNode[attr]
}
function animate (node, obj, speed, fn) {
  clearInterval(node.num)
  node.num = setInterval(function () {
    var flag = true
    for (var key in obj) {
      var v = parseInt(getStyleValue(node, key))
      if (v != obj[key]) {
        flag = false
      }
      var step = (obj[key] - v) / 100
      if (step > 0) {
        step = Math.ceil(step)
      } else if (step < 0) {
        step = Math.floor(step)
      }
      var v2 = v + step
      node.style[key] = v2 + 'px'
    }
    if (flag) {
      clearInterval(node.num)
      if (fn != undefined) {
        fn()
      }
    }
  }, speed = 10)
}
export default {
  name: 'ScrollBox',
  props: {
    imgArr: {
      type: Array,
      default: () => new Array(),
      required: true
    },
    promiseGetImg: {
      type: Function,
      default: null
    },
    autoPlay: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hightIndex: 0,
      lock: true,
      flag100: null,
    }
  },
  methods: {
    clickLi(index){
      if (this.lock) {
        this.lock = false
        this.hightIndex = index;
        var targetValue = -index * this.$refs.bannerNode.offsetWidth
        animate(this.$refs.contentNode, { left: targetValue }, 20, () => {
          this.lock = true
        })
      }
    },
    rightBtnFn(){
      if (this.lock) {
        this.lock = false
        var targetValue = -(this.hightIndex + 1) * this.$refs.bannerNode.offsetWidth
        var temp = this.hightIndex + 1;
        animate(this.$refs.contentNode, { left: targetValue }, 20,  () => {
          if (temp == this.imgArr.length) {
            this.$refs.contentNode.style.left = 0
          }
          this.lock = true
        })
        if (this.hightIndex + 1 == this.imgArr.length) {
          this.hightIndex = 0
        }else{
          this.hightIndex++;
        }
      }
    },
    leftBtnFn(){
      if (this.lock) {
        this.lock = false
        if (this.hightIndex - 1 < 0) {
          this.hightIndex = this.imgArr.length - 1
          this.$refs.contentNode.style.left =
            this.imgArr.length * -this.$refs.bannerNode.offsetWidth + 'px'
        }else{
          this.hightIndex--;
        }
        var targetValue = -this.hightIndex * this.$refs.bannerNode.offsetWidth
        animate(this.$refs.contentNode, { left: targetValue }, 20,  () => {
          this.lock = true
        })
      }
    },
    mouseEnterFn(){
      clearInterval(this.flag100)
    },
    mouseLeaveFn(){
      if(this.autoPlay){
        this.autoPlayFn()
      }
    },
    autoPlayFn(){
      if(this.imgArr.length <= 1){
        return false;
      }
      this.flag100 = setInterval(this.rightBtnFn, 12000)
    }
  },
  async mounted () {
    if(this.promiseGetImg){
      await this.promiseGetImg();
      setTimeout(() => {
        if(this.autoPlay){
          this.autoPlayFn()
        }
      }, 50)
    }else{
      setTimeout(() => {
        if(this.autoPlay){
          this.autoPlayFn()
        }
      }, 10)
    }
  }
}
</script>
<style lang="less" scoped>
.photos_img {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
// .banner_img {
//   width: 100%;
// }
// .banner_img li {
//   width: calc(100% / 1);
// }
.banner_img li img {
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  object-fit:cover;
}
.left_btn_img {
  width: 0.26rem;
  height: 0.26rem;
  border-top: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
  transform: rotate(-135deg);
  cursor: pointer;
  position: absolute;
  top: 50%;
  left: 0.1rem;
  margin-top: -0.13rem;
  z-index: 999;
}
.right_btn_img {
  width: 0.26rem;
  height: 0.26rem;
  border-top: 2px solid #ffffff;
  border-right: 2px solid #ffffff;
  transform: rotate(45deg);
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 0.1rem;
  margin-top: -0.08rem;
  z-index: 999;
}
.left_btn_img:hover,
.right_btn_img:hover {
  border-color: #6acafb;
}
.circle_img {
  width: 5rem !important;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 85%;
  left: 50%;
  margin-left: -2.5rem;
  height: 0.2rem;
}
.circle_img li {
  list-style: none;
  width: 0.2rem;
  height: 0.2rem;
  border-radius: 50%;
  background-color: #ffffff;
  cursor: pointer;
}
.circle_img li:hover {
  background-color: #6acafb;
}
.circle_img li.on {
  background-color: #6acafb;
}
.banner_img {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.banner_img li {
  list-style: none;
  height: 100%;
  float: left;
}
</style>